import { defineComponent as V, h as m, withDirectives as j, inject as k, ref as P, onMounted as _, onBeforeUnmount as U, watch as a, nextTick as X, toRef as h } from "vue";
import { useSsrAdapter as Y } from "./highrise721.mjs";
import q from "./highrise718.mjs";
import { getPlacementAndOffsetOfFollower as G, getOffset as H, getProperTransformOrigin as J } from "./highrise1382.mjs";
import { getPointRect as K, getRect as p } from "./highrise1380.mjs";
import Q from "./highrise641.mjs";
import A from "./highrise628.mjs";
import { c as d, cssrAnchorMetaName as Z } from "./highrise722.mjs";
import ee from "./highrise629.mjs";
import te from "./highrise635.mjs";
const ne = d([
  d(".v-binder-follower-container", {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    height: "0",
    pointerEvents: "none",
    zIndex: "auto"
  }),
  d(".v-binder-follower-content", {
    position: "absolute",
    zIndex: "auto"
  }, [
    d("> *", {
      pointerEvents: "all"
    })
  ])
]), me = V({
  name: "Follower",
  inheritAttrs: !1,
  props: {
    show: Boolean,
    enabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    syncTrigger: {
      type: Array,
      default: ["resize", "scroll"]
    },
    to: [String, Object],
    flip: {
      type: Boolean,
      default: !0
    },
    internalShift: Boolean,
    x: Number,
    y: Number,
    width: String,
    minWidth: String,
    containerClass: String,
    teleportDisabled: Boolean,
    zindexable: {
      type: Boolean,
      default: !0
    },
    zIndex: Number,
    overlap: Boolean
  },
  setup(n) {
    const t = k("VBinder"), o = A(() => n.enabled !== void 0 ? n.enabled : n.show), v = P(null), g = P(null), b = () => {
      const { syncTrigger: e } = n;
      e.includes("scroll") && t.addScrollListener(r), e.includes("resize") && t.addResizeListener(r);
    }, y = () => {
      t.removeScrollListener(r), t.removeResizeListener(r);
    };
    _(() => {
      o.value && (r(), b());
    });
    const B = Y();
    ne.mount({
      id: "vueuc/binder",
      head: !0,
      anchorMetaName: Z,
      ssr: B
    }), U(() => {
      y();
    }), ee(() => {
      o.value && r();
    });
    const r = () => {
      if (!o.value)
        return;
      const e = v.value;
      if (e === null)
        return;
      const O = t.targetRef, { x, y: R, overlap: l } = n, i = x !== void 0 && R !== void 0 ? K(x, R) : p(O);
      e.style.setProperty("--v-target-width", `${Math.round(i.width)}px`), e.style.setProperty("--v-target-height", `${Math.round(i.height)}px`);
      const { width: f, minWidth: c, placement: z, internalShift: E, flip: N } = n;
      e.setAttribute("v-placement", z), l ? e.setAttribute("v-overlap", "") : e.removeAttribute("v-overlap");
      const { style: s } = e;
      f === "target" ? s.width = `${i.width}px` : f !== void 0 ? s.width = f : s.width = "", c === "target" ? s.minWidth = `${i.width}px` : c !== void 0 ? s.minWidth = c : s.minWidth = "";
      const C = p(e), W = p(g.value), { left: S, top: T, placement: u } = G(z, i, C, E, N, l), L = J(u, l), { left: I, top: D, transform: F } = H(u, W, i, T, S, l);
      e.setAttribute("v-placement", u), e.style.setProperty("--v-offset-left", `${Math.round(S)}px`), e.style.setProperty("--v-offset-top", `${Math.round(T)}px`), e.style.transform = `translateX(${I}) translateY(${D}) ${F}`, e.style.setProperty("--v-transform-origin", L), e.style.transformOrigin = L;
    };
    a(o, (e) => {
      e ? (b(), w()) : y();
    });
    const w = () => {
      X().then(r).catch((e) => console.error(e));
    };
    [
      "placement",
      "x",
      "y",
      "internalShift",
      "flip",
      "width",
      "overlap",
      "minWidth"
    ].forEach((e) => {
      a(h(n, e), r);
    }), ["teleportDisabled"].forEach((e) => {
      a(h(n, e), w);
    }), a(h(n, "syncTrigger"), (e) => {
      e.includes("resize") ? t.addResizeListener(r) : t.removeResizeListener(r), e.includes("scroll") ? t.addScrollListener(r) : t.removeScrollListener(r);
    });
    const M = te(), $ = A(() => {
      const { to: e } = n;
      if (e !== void 0)
        return e;
      M.value;
    });
    return {
      VBinder: t,
      mergedEnabled: o,
      offsetContainerRef: g,
      followerRef: v,
      mergedTo: $,
      syncPosition: r
    };
  },
  render() {
    return m(q, {
      show: this.show,
      to: this.mergedTo,
      disabled: this.teleportDisabled
    }, {
      default: () => {
        var n, t;
        const o = m("div", {
          class: ["v-binder-follower-container", this.containerClass],
          ref: "offsetContainerRef"
        }, [
          m("div", {
            class: "v-binder-follower-content",
            ref: "followerRef"
          }, (t = (n = this.$slots).default) === null || t === void 0 ? void 0 : t.call(n))
        ]);
        return this.zindexable ? j(o, [
          [
            Q,
            {
              enabled: this.mergedEnabled,
              zIndex: this.zIndex
            }
          ]
        ]) : o;
      }
    });
  }
});
export {
  me as default
};
